<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
    <!-- <get-price :getPrice="getPrice" /> -->
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
// import getPrice from '@/component/categories/GetPriceSection'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import RetirementData from '@/data/company-page-data/fiba-emeklilik/cross-pages/Retirement'
export default {
  metaInfo: {
    title: 'Fiba Emeklilik Bireysel Emeklilik Sistemi (BES) Başvuru',
    meta: [
      {
        name: 'description',
        content: 'Fibaemeklilik  bireysel emeklilik sistemine giriş yaparak %25 devlet katkısı ile online BES hesabınızı oluşturun, geleceğiniz için bugünden birikim yapmaya başlayın.'
      }
    ]
  },
  name: 'FibaEmeklilikRetirement',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    // getPrice,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: RetirementData.headerContent,
      crossPageContent: RetirementData.crossPageContent,
      faqTitle: RetirementData.faqTitle,
      faqTitleDesc: RetirementData.faqTitleDesc,
      questions: RetirementData.questions,
      getPrice: RetirementData.getPrice
    }
  }
}
</script>
